import { ArrowRight } from 'cwp-components/forms/ArrowRight'

export const LawSearchButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <button
      onClick={onClick}
      className='w-full self-stretch p-5 bg-white rounded-[40px] shadow-[0px_4px_20px_0px_rgba(0,26,61,0.12)] inline-flex flex-col justify-start items-center gap-12'
    >
      <div className='self-stretch inline-flex justify-end items-start gap-3'>
        <div className='flex-1 inline-flex flex-col justify-start items-end gap-3'>
          <div className='self-stretch inline-flex justify-end items-center gap-3'>
            <div className="justify-start text-slate-900 text-2xl font-bold font-['DM_Sans'] leading-loose tracking-wide">
              Law Finder
            </div>
            <ArrowRight fill='#00323D' />
          </div>
          <div className='self-stretch px-10 inline-flex justify-end items-center gap-2.5'>
            <div className="flex-1 text-right justify-start text-slate-500 text-base font-medium font-['DM_Sans'] leading-normal tracking-wide">
              Type in an explanation to get help finding the correct area of
              law..
            </div>
          </div>
        </div>
      </div>
    </button>
  )
}
